import BitsyApollo from './BitsyApollo';
import Features from './Features';

/* Which product the subscription premium upgrade offers.

   There are two premium upgrade products on the account. checkout-single-page's
   Start Membership names one of them in Statsig and adds that; the server's
   pre-checkout promo record names the other. An offer made in two places has to
   name one product, so the id comes from here.

   2024checkout_-_premium_first_month_free has ended with the test arm winning,
   so the first month is free for everyone and there is no longer a decision to
   read. That matters more than it sounds: an ended experiment answers .get()
   with the fallback passed to it, so the old branch — which asked the ended
   experiment whether the free month was on — had started answering "no" and
   quietly serving the losing arm's product.

   The winning product's id is still read from the decided experiment where
   Statsig serves it, and from the dynamic config otherwise, which is where the
   id belongs now that the experiment is over. */
const FREE_MONTH_EXPERIMENT = '2024checkout_-_premium_first_month_free';
const DEFAULT_PRODUCT_CONFIG = 'consumer-premiumupdate-defaultproductid';

export const getPremiumUpgradeProductId = () => {
  const decided = Features.getExperiment(FREE_MONTH_EXPERIMENT).get(
    'experimentProductId',
    null,
  );
  if (decided) return decided;

  return Features.getConfig(DEFAULT_PRODUCT_CONFIG)?.value?.productId || null;
};

/* Null rather than a throw when Statsig names no product or the fetch fails:
   the caller falls back to the server's promo record, so a config that has not
   been set yet costs the configured product, not the offer itself. */
export const fetchPremiumUpgradeProduct = async () => {
  const productId = getPremiumUpgradeProductId();
  if (!productId) return null;

  const product = await BitsyApollo.getProduct({ productId });
  if (!product || product.error || !product._id) return null;
  return product;
};

